import { render, staticRenderFns } from "./clapper.vue?vue&type=template&id=2ad73234&"
import script from "./clapper.vue?vue&type=script&lang=js&"
export * from "./clapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports